export const measurementTypes = [
  {
    value: "BP",
    label: "Blood Pressure",
  },
  {
    value: "ECG",
    label: "Electrocardiogram",
  },
  {
    value: "SpO2",
    label: "Oxygen saturation",
  },
  {
    value: "BT",
    label: "Body Temperature",
  },
  {
    value: "BG",
    label: "Blood Glucose",
  },
  {
    value: "HR",
    label: "Heart Rate",
  },
  {
    value: "RR",
    label: "Respiratory Rate",
  },
  {
    value: "WEI",
    label: "Weight",
    extra: "Weight and Size",
  },
  {
    value: "SIZ",
    label: "Size",
    disabled: true,
  },
  {
    value: "BOM",
    label: "Body Mass Index",
    disabled: true,
  },
  {
    value: "FAT",
    label: "Fat",
  },
  {
    value: "MM",
    label: "Muscle Mass",
  },
  {
    value: "MUS",
    label: "Muscle",
  },
  {
    value: "KCAL",
    label: "Kilocalories",
  },
  {
    value: "WAT",
    label: "Water",
  },
];

export const showExtraOnSelect = ["WEI"];

export const BgMeasurementTypes = [
  {
    value: "mg/dl",
    label: "mg/dl",
  },
  {
    value: "mmol/L",
    label: "mmol/L",
  },
];

export const measurementNormalText = [
  "SpO2",
  "FAT",
  "MM",
  "MUS",
  "WAT",
  "BT",
  "WEI",
  "SIZ",
  "KCAL",
  "HR",
  "RR",
];
export const measurementPrompt = {
  BT: "°C",
  SpO2: "%",
  FAT: "%",
  MM: "kg",
  MUS: "%",
  WAT: "%",
  WEI: "kg",
  SIZ: "cm",
  KCAL: "kcal",
  HR: "lpm",
  RR: "rpm",
};

export const clinicalRanges = {
  BP: {
    Systolic: {
      normal: [90, 120],
      alert: [121, 140],
      alertLow: [80, 89],
      unit: "mmHg",
      label: "Systolic",
    },
    Diastolic: {
      normal: [60, 80],
      alert: [81, 90],
      alertLow: [50, 59],
      unit: "mmHg",
      label: "Diastolic",
    },
  },
  SpO2: {
    SpO2: {
      normal: [95, 100],
      alert: [90, 94],
      unit: "%",
      label: "SpO2",
    },
  },
  BG: {
    BG: {
      normal: [70, 140],
      alert: [141, 200],
      alertLow: [54, 69],
      unit: "mg/dL",
      label: "Blood Glucose",
    },
  },
  BT: {
    BT: {
      normal: [36.1, 37.2],
      alert: [37.3, 38.0],
      alertLow: [35.0, 36.0],
      unit: "°C",
      label: "Body Temp",
    },
  },
  HR: {
    HR: {
      normal: [60, 100],
      alert: [101, 120],
      alertLow: [50, 59],
      unit: "lpm",
      label: "Heart Rate",
    },
  },
  RR: {
    RR: {
      normal: [12, 20],
      alert: [21, 24],
      alertLow: [8, 11],
      unit: "rpm",
      label: "Respiratory Rate",
    },
  },
};

export const statusColors = {
  normal: "#4caf50",
  alert: "#ff9800",
  critical: "#f44336",
};
